import { render } from "./CreateTask.vue?vue&type=template&id=08f02f36&scoped=true"
import script from "./CreateTask.vue?vue&type=script&lang=js"
export * from "./CreateTask.vue?vue&type=script&lang=js"

import "./CreateTask.vue?vue&type=style&index=0&id=08f02f36&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08f02f36"]])

export default __exports__